module.exports = __webpack_public_path__ + "img/img_sample1.a0bf4878.jpg";